import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const publicStatsContract = c.router(
  {
    getHomepageStats: {
      method: 'GET',
      path: '/homepage',
      responses: {
        200: z.object({
          treesPlantedCount: z.number(),
          prizesWonCount: z.number(),
          winnersLastWeek: z.number(),
          prizesWonValue: z.number(),
        }),
        404: c.type<{ message: string }>(),
      },
    },
  },
  {
    pathPrefix: '/public',
  },
);
